var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFull3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.126 1.783V3.075H9.843V4.639H8.024C7.84267 5.71567 7.395 6.49767 6.681 6.985C5.97833 7.47233 4.913 7.716 3.485 7.716V8.617C3.485 9.14967 3.59267 9.569 3.808 9.875C4.03467 10.181 4.41433 10.334 4.947 10.334C5.457 10.334 5.82533 10.1923 6.052 9.909C6.27867 9.61433 6.392 9.18933 6.392 8.634H8.602C8.57933 9.77867 8.25633 10.657 7.633 11.269C7.00967 11.8697 6.12 12.17 4.964 12.17C3.76267 12.17 2.84467 11.847 2.21 11.201C1.57533 10.555 1.258 9.61433 1.258 8.379V6.118C2.47067 6.118 3.366 6.08967 3.944 6.033C4.522 5.965 4.95267 5.829 5.236 5.625C5.51933 5.421 5.70633 5.09233 5.797 4.639H0.714V3.075H5.882V1.783H0.714V0.116999H9.843V1.783H8.126Z",
    fill: "#00C838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFull3);
export default __webpack_public_path__ + "static/media/full-3.c34f348f2daf381e21af82963af85205.svg";
export { ForwardRef as ReactComponent };